var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M13.22 11.934h-.677l-.24-.232A5.573 5.573 0 0 0 8.075 2.5a5.574 5.574 0 1 0 0 11.149 5.55 5.55 0 0 0 3.627-1.346l.232.24v.677l4.288 4.28 1.278-1.278-4.28-4.288zm-5.145 0a3.855 3.855 0 0 1-3.86-3.86 3.854 3.854 0 0 1 3.86-3.859 3.854 3.854 0 0 1 3.859 3.86 3.854 3.854 0 0 1-3.86 3.859z"
  })));
};
export default SvgSearch;